/* Imaging screens: the worklist, the exam, reports and Settings > Imaging (DESIGN.md §7,
 * §8; docs/plans/phase2-radiology.md §6). Neutral tokens only; states are words. */

.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.section {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.sectionHeading {
  margin: 0;
  font: var(--t-heading);
}

.meta {
  margin: 0;
  color: var(--graphite);
  font: var(--t-small);
}

.stack {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
}

.facts {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: var(--space-2) var(--space-5);
  margin: 0;
}

.facts dt {
  color: var(--graphite);
  font: var(--t-small);
}

.facts dd {
  margin: 0;
  overflow-wrap: anywhere;
}

.prose {
  max-width: 75ch;
  margin: 0;
  white-space: pre-wrap;
  line-height: 1.55;
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.report {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.reportHeading {
  margin: 0;
  font: var(--t-body-strong);
}

.versions {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  margin: 0;
  padding: 0;
  list-style: none;
}

.version {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding-top: var(--space-3);
  border-top: 1px solid var(--rule);
}

.waiting {
  font-variant-numeric: tabular-nums;
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  margin: 0;
  padding: 0;
  list-style: none;
}

.listItem {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding-bottom: var(--space-4);
  border-bottom: 1px solid var(--rule);
}

.listItem:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}

.itemHead {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-2);
}

.preview {
  max-height: 60vh;
  overflow: auto;
}

.preview:focus-visible {
  outline: var(--focus-ring);
  outline-offset: 2px;
}

.sheetBody {
  display: flex;
  flex-direction: column;
  gap: 4mm;
}

.sheetHeading {
  margin: 0;
  font-weight: 600;
}

.sheetText {
  margin: 0;
  white-space: pre-wrap;
}
